import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  InitializeTrainerSessionRequest,
  TrainerSessionResponse,
} from '@thiememeulenhoff/types';
import { TrainerEndpointsService } from './trainer.endpoints.service';

const toFormBody = (payload: InitializeTrainerSessionRequest): string => {
  const params = new URLSearchParams();

  params.set('arrangementCode', payload.arrangementCode);
  params.set('wordListId', payload.wordListId);
  params.set('context', payload.context);
  params.set('answerMethod', payload.answerMethod);
  params.set('randomOrder', String(payload.randomOrder));
  params.set('timezone', payload.timezone);

  return params.toString();
};

@Injectable({
  providedIn: 'root',
})
export class TrainerService {
  readonly #http = inject(HttpClient);

  readonly #endpoints = inject(TrainerEndpointsService);

  initializeSession(payload: InitializeTrainerSessionRequest) {
    const endpoint = this.#endpoints.session();

    return this.#http.post<TrainerSessionResponse>(
      endpoint,
      toFormBody(payload),
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
        }),
      },
    );
  }
}
